import { parseDomain } from '@wix/domains-serverless-interface';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { createApiClient, createQueriesConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra-react';
import { getCandidateTlds } from './tldOfferWidget.utils';
const apiConfig = createQueriesConfig({
  tldCandidates: {
    queryFn: async _ref => {
      let httpClient = _ref.httpClient,
        domain = _ref.request.domain;
      const _DomainsApiClient$que = DomainsApiClient.queries({
          httpClient
        }),
        listSuggestedTlds = _DomainsApiClient$que.listSuggestedTlds,
        domainTlds = _DomainsApiClient$que.domainTlds;
      const parsedDomain = parseDomain(domain);
      const _await$Promise$all = await Promise.all([listSuggestedTlds({}), domainTlds({})]),
        _await$Promise$all$0$ = _await$Promise$all[0].tlds,
        suggestedTlds = _await$Promise$all$0$ === void 0 ? [] : _await$Promise$all$0$,
        _await$Promise$all$1$ = _await$Promise$all[1].tlds,
        catalog = _await$Promise$all$1$ === void 0 ? [] : _await$Promise$all$1$;
      return {
        sld: parsedDomain.sld ?? '',
        topTlds: suggestedTlds.filter(tld => tld !== parsedDomain.tld),
        candidates: getCandidateTlds(suggestedTlds, catalog.map(catalogTld => catalogTld.tld), parsedDomain.tld ?? '')
      };
    },
    queryConfigType: QueryConfigTypes.STATIC_DATA
  },
  tldOfferPrices: {
    queryFn: async _ref2 => {
      let httpClient = _ref2.httpClient,
        tldBatches = _ref2.request.tldBatches;
      const _DomainsApiClient$que2 = DomainsApiClient.queries({
          httpClient
        }),
        listTldDisplayPrices = _DomainsApiClient$que2.listTldDisplayPrices;
      const chunks = tldBatches.flatMap(tlds => Array.from({
        length: Math.ceil(tlds.length / 50)
      }, (_, index) => tlds.slice(index * 50, (index + 1) * 50)));
      const responses = await Promise.all(chunks.map(tlds => listTldDisplayPrices({
        tlds
      }, {
        staleTime: Infinity,
        cacheTime: Infinity
      })));
      return {
        displayPrices: responses.flatMap(_ref3 => {
          let _ref3$displayPrices = _ref3.displayPrices,
            displayPrices = _ref3$displayPrices === void 0 ? [] : _ref3$displayPrices;
          return displayPrices;
        })
      };
    },
    queryConfigType: QueryConfigTypes.STATIC_DATA
  }
});
export const tldOfferWidgetApiClient = createApiClient(apiConfig);
//# sourceMappingURL=tldOfferWidget.apiClient.js.map